import { Link } from "react-router";
import { AuthForm } from "@/app/components/AuthForm";
import { AuthLayout } from "@/app/components/auth/AuthLayout";
import { useAuth } from "@/app/lib/auth-context";

export function LoginScreen() {
  const { login } = useAuth();
  return (
    <AuthLayout
      headline={<>Welcome <span className="text-moss">back</span></>}
      subtitle="Sign in to tend your garden."
    >
      <AuthForm
        submitLabel="Sign in"
        busyLabel="Signing in…"
        minPasswordLength={8}
        onSubmit={login}
        aside={
          <Link to="/reset-password" className="auth-forgot-link">
            Forgot password?
          </Link>
        }
        footer={
          <>
            New here?{" "}
            <Link to="/signup" className="text-moss font-medium hover:underline">Create an account</Link>
          </>
        }
      />
    </AuthLayout>
  );
}
